const swiper = new Swiper('.custom-logo_slider', {
      slidesPerView: 6,
      spaceBetween: 20,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        320: { slidesPerView: 2 },
        480: { slidesPerView: 3 },
        575: { slidesPerView: 4 },
        768: { slidesPerView: 5 },
        992: { slidesPerView: 7 },
        1200: { slidesPerView: 8 },
        1400: { slidesPerView: 9 },
      }
    });